import React, { useState } from 'react';
import '../../../Styles/Renderer/inlineCodeBlock.css';
import { HoverToolTip } from '../../../components/Layout/Items/HoverToolTip';

export default function InlineCodeBlock({ children }: { children: React.ReactNode }) {
    const [isCopied, setIsCopied] = useState(false);
    
    const onClick = (e: React.MouseEvent<HTMLSpanElement>) => {
        const selection = window.getSelection();
        if (selection && selection.toString().length === 0) {
            e.preventDefault();
            e.stopPropagation();
            navigator.clipboard.writeText(children as string);
            setIsCopied(true);
            setTimeout(() => setIsCopied(false), 750);
        }
    };
    return (
        <span className="ai-response-inline-code" onClick={onClick}>
            {children}
            {isCopied && <HoverToolTip text="Copied" position="bottom" />}
        </span>
    );
}